
import { Helmet } from "react-helmet";

const EnglishTermsPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>Terms of Service - Lainasampo.fi</title>
        <meta name="description" content="Terms of Service for Lainasampo.fi loan comparison service" />
      </Helmet>
      
      <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-sm">
        <h1 className="text-3xl font-bold text-blue-800 mb-6">Terms of Service</h1>

        <div className="prose prose-blue max-w-none">
          <p className="text-sm text-gray-500 mb-4">
            This is a translation of our Finnish Terms of Service. The Finnish version is the legally binding version.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">1. Service Description</h2>
          <p className="mb-4">
            Lainasampo.fi is a loan comparison and application service that forwards loan applications to its partners. 
            Lainasampo.fi does not itself grant loans, but acts as an intermediary between customers and financial institutions.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">2. Use of Service</h2>
          <p className="mb-4">When using our service, you must:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li>Provide correct and up-to-date information in your loan application</li>
            <li>Be at least 18 years old and legally competent</li>
            <li>Use the service only for lawful purposes</li>
            <li>Comply with Finnish law and these terms of service</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">3. Loan Applications</h2>
          <p className="mb-4">By submitting a loan application through Lainasampo.fi:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li>You authorize us to forward your application to our partners</li>
            <li>You accept that our partners may check your credit information</li>
            <li>You understand that the final loan decision is made by the financial institution, not Lainasampo.fi</li>
            <li>You accept that we may contact you regarding your loan application</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">4. Loan Offers</h2>
          <p className="mb-4">
            Loan offers are made by our partners. We cannot guarantee that you will receive loan offers or that the offers 
            will meet your expectations. The terms of the offers you receive depend on several factors, such as your credit 
            information, income, and the lending policies of the financial institutions.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">5. Free of Charge</h2>
          <p className="mb-4">
            Lainasampo.fi's services are free of charge for customers. We finance our operations through commissions 
            paid by our partners.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">6. Limitations of Liability</h2>
          <p className="mb-4">Lainasampo.fi is not responsible for:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li>Loan decisions made by partners or the terms of their offers</li>
            <li>Loan repayment or relationships between the borrower and lender</li>
            <li>Indirect or consequential damages that may result from using the service</li>
            <li>Temporary service interruptions or technical problems</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">7. Intellectual Property Rights</h2>
          <p className="mb-4">
            All content on Lainasampo.fi, including texts, images, logos, computer programs, and other material, 
            is protected by intellectual property rights and belongs to Lainasampo Oy or its licensors. Copying, 
            distributing, or other use of the content without permission is prohibited.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">8. Communication</h2>
          <p className="mb-4">
            By using our service, you accept that we may send you information about our service, your loan application, 
            and loan offers via email or other electronic means. You may at any time revoke your consent to marketing 
            communications by contacting our customer service.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">9. Changes to Terms</h2>
          <p className="mb-4">
            We reserve the right to modify these terms of service. We will publish the modified terms on our website 
            and they will take effect immediately. Continued use of the site after the changes to the terms will be 
            considered as acceptance of the new terms.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">10. Applicable Law and Dispute Resolution</h2>
          <p className="mb-4">
            These terms of service are governed by Finnish law. Any disputes will primarily be resolved through 
            negotiation. If an agreement cannot be reached, disputes will be resolved in the Helsinki District Court.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">11. Contact Information</h2>
          <p className="mb-4">If you have any questions about the terms of service, please contact:</p>
          <p>
            Lainasampo Oy<br />
            Email: asiakaspalvelu@lainasampo.fi
          </p>
        </div>
      </div>

      <p className="text-sm text-gray-500 text-center mt-8 mb-8">These terms were last updated on: June 1, 2023</p>
    </div>
  );
};

export default EnglishTermsPage;
